import "./App.css";
import React, { Component } from "react";
import Messenger from "./components/Messenger";
import Login from "./components/Login/login";
import Global from "./customlib/Global";
import Api from "./customlib/Api";
import {
    BrowserRouter as Router,
    Route,
    Switch
  } from "react-router-dom";
import socketIOClient from "socket.io-client";
import SettingsResponsive from "./components/Settings/SettingsResponsive";
import DataPending from "./components/DataPending";
import DailyClosingRateReport from "./components/ContactLeadsReport/DailyClosingRateReport";
import base64 from "base-64";
import utf8 from "utf8";

import { withOneTabEnforcer } from "react-one-tab-enforcer"
import OneTabWarning from "./components/OneTabWarning";
import DataCancelDashboard from "./components/DataPending/DataCancelDashboard";
import crypto from "crypto-js";
import MonitoringPerpindahanContact from "./components/Monitoring/PerpindahanContact";
import DataPendingLeadsTabs from "./components/DataPending/DatapendingLeadsTabs";
import AnalisaDataCancel from "./components/DataPending/AnalisaDataCancel";
import DashboardPerformaSales from "./components/DashboardPerformaSales";
import { Box, LinearProgress } from "@mui/material";
import CheckpointClient from "./components/CheckpointClient";
import DashboardTele from "./components/DashboardTele";
import axios from "axios";
import { Container } from "react-bootstrap";
import { Warning } from "@mui/icons-material";
import TeamLeader from "./components/TeamLeader";
import ModulTrainingTele from "./components/FiveWhysTele/ModulTrainingTele";
import WahaNotify from "./components/WahaNotify";
import FeaturesSettings from "./components/FeaturesSettings";
import BlastTelemarketing from "./components/BlastTelemarketing";
import CsTicketSettings from "./components/CustomerServiceHelp/CsTicketSettings";
import CsAutoReplyTemplates from "./components/CustomerServiceHelp/CsAutoReplyTemplates";
import SpvControlPanel from "./components/SpvControlPanel";

var socket;
class App extends Component {
  state = {
    auth: {},
    validAuth: false,
    isValidating: false,
    isValidationSuccess: true,
    validationErrMessage: ""
  };

  constructor() {
    super();

    let lotusConsoleEnabled = localStorage.getItem("lotus_console_enabled");
    console.log("LOTUS_DEBUG_MODE", lotusConsoleEnabled);

    if(lotusConsoleEnabled !== null && lotusConsoleEnabled !== undefined){
      console.log("CONSOLE ITEM", lotusConsoleEnabled);
      if (lotusConsoleEnabled === "false") {
        console.log("CONSOLE DISABLED");
        console.log = () => {};
        console.debug = () => {};
        console.info = () => {};
        console.warn = () => {};
        console.error = () => {};
      }
    }else{
      console.log("CONSOLE API");
      if (!Api.isConsoleEnabled) {
        console.log("CONSOLE ENABLED");
        console.log = () => {};
        console.debug = () => {};
        console.info = () => {};
        console.warn = () => {};
        console.error = () => {};
      }
    }

    socket = socketIOClient(Api.getSocketUrl());
    Global.setSocket(socket);
    // console.log("SOCKET INITIATED AT : " + Api.getSocketUrl());
    //   Global.setSocket(socket);
  }

  componentDidMount() {

    const queryParams = new URLSearchParams(window.location.search);
    let refValue = queryParams.get("autoSignin");
    console.log("AUTOSIGN", 1, refValue);
    if(refValue){
      console.log("AUTOSIGN", 2);
      this.setState({isValidating: true}, () => {
        this.validateAuth(refValue);
      });
    }else{
      this.initAppState();
      this.readTeleQueryParams();
      this.readFuQueryParams();
      this.readOpenChatQueryParams();
    }
  }
  
  validateAuth = (id) => {
    console.log("AUTOSIGN", 3);
      let params = {
          id: id
      } 
      
      console.log("AUTOSIGN", 4);
      axios
      .post(Api.validateAuth(), params, Api.getRequestHeaderNoAuth())
      .then((response) => {
          console.log("AUTOSIGN", 5);
          let responseData = response.data;
          console.log("AUTOSIGN", 6);
          if(responseData.success === true){
            console.log("AUTOSIGN", 7);
              localStorage.removeItem("auth");
              console.log("AUTOSIGN", 8);
              let strResponseData = JSON.stringify(responseData.data);
              console.log("AUTOSIGN", 9);
              var cipherText = crypto.AES.encrypt(strResponseData, Global.getStringRequirements()).toString();
              console.log("AUTOSIGN", 10);
              localStorage.setItem("auth", cipherText);
              console.log("AUTOSIGN", 11);
              window.location.href = "/";
              console.log("AUTOSIGN", 12);
          }else{
            this.setState({isValidating: false, isValidationSuccess: false, validationErrMessage: responseData.message});
          }
      })
      .catch((error) => {
          this.setState({ errorMessage: error.message, isValidating: false });
          console.error("There was an error!", error);
      });
  }

  readTeleQueryParams = () => {
    // const queryParams = new URLSearchParams(window.location.search);
    // let refValue = queryParams.get("ref");
    // console.log("ORIREFVALUE", refValue);

    // if(refValue !== null && refValue !== undefined && refValue.length > 0){
    //   try {
    //     let refData = base64.decode(queryParams.get("ref"));
    //     refData = utf8.decode(refData);
    //     let refDataParsed = JSON.parse(refData);
    //     localStorage.setItem("ref", JSON.stringify(refDataParsed));
    //     console.log("QUERYPARAMS", refDataParsed);
    //   } catch (error) {
    //     localStorage.removeItem("ref");
    //   }
    // }else{
    //   localStorage.removeItem("ref");
    // }
  }

  readFuQueryParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    let refValue = queryParams.get("fu");
    console.log("ORIREFVALUE", refValue);

    if(refValue !== null && refValue !== undefined && refValue.length > 0){
      try {
        // let refData = Buffer.from(queryParams.get("fu"), 'base64').toString('utf-8');
        let refData = base64.decode(queryParams.get("fu"));
        refData = utf8.decode(refData);
        let refDataParsed = JSON.parse(refData);
        localStorage.setItem("fu", JSON.stringify(refDataParsed));
        console.log("QUERYPARAMS", refDataParsed);
        // let history = useHistory();
        // history.push("/");
      } catch (error) {
        localStorage.removeItem("fu");
      }
    }else{
      localStorage.removeItem("fu");
    }
  }

  readOpenChatQueryParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    let refValue = queryParams.get("openChat");
    console.log("ORIREFVALUE", refValue);

    if(refValue !== null && refValue !== undefined && refValue.length > 0){
      try {
        // let refData = Buffer.from(queryParams.get("fu"), 'base64').toString('utf-8');
        let refData = base64.decode(queryParams.get("openChat"));
        refData = utf8.decode(refData);
        let refDataParsed = JSON.parse(refData);
        localStorage.setItem("openChat", JSON.stringify(refDataParsed));
        console.log("QUERYPARAMS_OPENCHAT", refDataParsed);
        // let history = useHistory();
        // history.push("/");
      } catch (error) {
        localStorage.removeItem("openChat");
      }
    }else{
      localStorage.removeItem("openChat");
    }
  }


  initAppState = () => {

    let authData = {};
    try {
      let strAuthCipher = localStorage.getItem("auth");
      console.log("strAuthCipher", strAuthCipher);
      let plainTextBytes = crypto.AES.decrypt(strAuthCipher, Global.getStringRequirements());
      let plainText = plainTextBytes.toString(crypto.enc.Utf8);

      // let authData = JSON.parse(localStorage.getItem("auth"));
      authData = JSON.parse(plainText);  
      // Global.setPropertiesConsoleEnabled(Api.isConsoleEnabled);
    } catch (error) {
      localStorage.removeItem("auth");
      console.log(error);
    }
    
    let validAuth = authData && authData.user && authData.access_token.length > 0;

    // console.log("AUTHDATA", authData, validAuth);
    Global.add(authData);
    this.setState({ auth: authData, validAuth: validAuth }, () => {
      if(validAuth){
        socket = socketIOClient(Api.getSocketUrl());
        Global.setSocket(socket);
        Global.getSocket().on("connect", () => {
          Global.getSocket().emit("register", {
            userId: authData.user.id,
            userName: authData.user.name,
            appProfileId: authData.appProfile._id,
            appLabel: authData.appProfile.label,
            appWaNumber: authData.appProfile.waNumber
          });
        });
      }
    });
    // Global.add(authData);
  };

  handleAuthChange = () => {
    this.initAppState();
  };

  // componentWillUnmount(){
  //   localStorage.setItem("test", "halooo");
  // }

  render() {
    // console.log("STATE_RENDER", this.state);
    // console.log("STATE_AUTH_RENDER", this.state.auth);
    // console.log("STATE_VALIDAUTH_RENDER", this.state.validAuth);
    return (

        <Box>
          <CheckpointClient />
          <WahaNotify />
          
          {
            this.state.isValidating && (
              <Box sx={{textAlign: "center", paddingTop: "0vh", paddingLeft: "00vw", paddingRight: "00vw"}}>
                <LinearProgress />
                <Box sx={{marginTop: "40vh"}}>
                  Authenticating, please wait ....
                </Box>
              </Box>
            )
          }

          {
            !this.state.isValidating && !this.state.isValidationSuccess && (
              <Box sx={{textAlign: "center", paddingTop: "0vh", paddingLeft: "00vw", paddingRight: "00vw"}}>
                {/* <LinearProgress /> */}
                <Box sx={{marginTop: "40vh"}}>
                  <Warning sx={{width: "100px"}} color="error"/><br />
                  {this.state.validationErrMessage}
                </Box>
              </Box>
            )
          }

          {
            this.state.isValidating ? <></> : !this.state.isValidationSuccess ? <></> : this.state.validAuth ? 
              (
                  <Router>
                      <Switch>
                          <Route exact path="/">
                              <Messenger onAuthChange={this.handleAuthChange} />
                          </Route>
                          <Route path="/setting">
                              <SettingsResponsive />
                          </Route>
                          {/* <Route path="/setup-module-training">
                              <SetupModulTraining />
                          </Route> */}
                          <Route path="/data-pending">
                              <DataPending />
                          </Route>
                          <Route path="/closing-rate">
                              <DailyClosingRateReport />
                          </Route>
                          <Route path="/analisis-data-cancel">
                              {/* <DataCancelDashboard /> */}
                              <AnalisaDataCancel />
                          </Route>
                          <Route path="/riwayat-perpindahan-contact">
                              <MonitoringPerpindahanContact />
                          </Route>
                          <Route path="/leads-data-pending">
                              <DataPendingLeadsTabs />
                          </Route>
                          <Route path="/dashboard-performa-sales">
                              <DashboardPerformaSales />
                          </Route>
                          <Route path="/dashboard-tele">
                              <DashboardTele />
                          </Route>
                          <Route path="/team-leader">
                              <TeamLeader defaultType={"TELEMARKETING"} />
                          </Route>
                          <Route path="/modul-training-tele">
                              <ModulTrainingTele isStandalone={true} />
                          </Route>
                          <Route path="/features-settings">
                              <FeaturesSettings />
                          </Route>
                          <Route path="/blast-telemarketing">
                              <BlastTelemarketing />
                          </Route>
                          <Route path="/cs-ticket-settings">
                              <CsTicketSettings />
                          </Route>
                          <Route path="/cs-auto-reply-templates">
                              <CsAutoReplyTemplates />
                          </Route>
                          <Route path="/spv-control-panel">
                              <SpvControlPanel />
                          </Route>
                          <Route path="/cs-ticket-settings">
                              <CsTicketSettings />
                          </Route>
                          <Route path="/cs-auto-reply-templates">
                              <CsAutoReplyTemplates />
                          </Route>
                      </Switch>
                  </Router>
              ) : 
              (
                  <Login onLogin={this.handleAuthChange} />
              )
              }
          

          
        </Box>
    );
  }
}

export default withOneTabEnforcer({appName: "lotus-messaging", OnlyOneTabComponent: OneTabWarning})(App)
// export default App;
